<template>
    <div class="content">
        <h2>卫生监督意见书</h2>
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="编号:" prop="bh">
                        <el-input style="width:200px; margin-right:10px;"
                        v-model="form.bh"
                        placeholder="请输入"
                        clearable
                        size="small"
                        />
                        <el-button type="warning" size="small" @click="getWh">获取编号</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="改正情况:" prop="gzqk">
                        <el-radio-group v-model="form.gzqk" @change="getQzqk">
                            <el-radio label=0>立即改正</el-radio>
                            <el-radio label=1>天数</el-radio>
                        </el-radio-group>
                        <el-input type="number" v-if="form.gzqk == 1"
                        v-model="form.zgDay"
                        placeholder=""
                        clearable
                        size="small" style="width:140px;" @input="getZgday"
                        />日内整改完毕
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="监督意见:" prop="jdyj">
                        <!-- <p>针对{{anyou}}的行为，依据{{cfyj}}的规定，责令你单位</p> -->
                        <el-input type="textarea" rows="7"
                        v-model="form.jdyj"
                        placeholder="请输入"
                        clearable
                        size="small"
                        />
                        <el-button type="warning" size="small" @click="getNr()">选择模板</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label-width="0" style="text-align:center;">
                        <el-button type="primary" @click="submit('form')">生成卫生监督意见书</el-button>
                        <el-button type="warning" v-if="isWs" @click="show()">预览</el-button>
                        <el-button type="danger" v-if="isWs" @click="edit()">编辑</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-dialog title="监督意见" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false">
            <jdyj :wfss="this.wfss" :jdnr="this.jdnr" @handleBackJdyj="handleBackJdyj" @jdyjTk="closeJdyj"  />
        </el-dialog>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="卫生监督意见书" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import jdyj from './jdyj.vue'
export default {
    name: "Layout",
    props:['code','pcId','text','anyou','cfyj'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            gzbm:'',
            gzzw:'',
            jdnr:'',
            form:{
                blzt:2,
                qmfs:1
            },
            rules:{
                bh:[
                    { required: true, message: '现场笔录编号不能为空', trigger: 'blur' }
                ],
                xwrq:[
                    { required: true, message: '询问日期不能为空', trigger: ['change','blur'] }
                ],
                startTime:[
                    { required: true, message: '开始时间不能为空', trigger: ['change','blur'] }
                ],
                endTime:[
                    { required: true, message: '结束时间不能为空', trigger: ['change','blur'] }
                ],
                blzt:[
                    { required: true, message: '笔录状态不能为空', trigger: ['change','blur'] }
                ],
                jdyj:[
                    { required: true, message: '检查内容不能为空', trigger: 'blur' }
                ],
                qmfs:[
                    { required: true, message: '签名方式不能为空', trigger: 'blur' }
                ],
            },
            open:false,
            wfss:'',
            wsUrl:'',
            isWs:false,

            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            zfXX:[]
        }
    },
    components: {
        jdyj
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.gzbm = user.gzbm
        this.gzzw = user.gzzw
        if(this.hysj){
            this.$set(this.form,'xwrq',this.hysj)
        }
        this.wfss = this.text
        let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位'
        this.$set(this.form,'jdyj',tet)
        console.log(this.wfss)
        this.getList()
    },
    methods: {
        async getList(){
            this.isWs = false
            //判断文书是否存在
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getExistWenshu&id=${this.pcId}&fileName=${escape('卫生监督意见书')}&xcblFlag=`)
            if(data.data){
                if(data.data == '-1'){
                    this.getWh()
                }else{
                    this.isWs = true
                    //有
                    this.getZfxx()
                }
                
            }
        },
        async getZfxx(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.pcId}`)
            console.log(data)
            this.wsUrl = ''
            this.docurl = ''
            this.wsPdf = ''
            this.zfXX = []
            if(data.data){
                this.zfXX = data.data
                this.wsUrl = 'mid='+data.data[0].dwmc_id+'&lsh='+data.data[0].lsh+'&wsnameEw=weishengjianduyijianshu&sjs='+new Date().getTime()
                let nm = 'weishengjianduyijianshu'
                this.docurl = 'https://dapc.scqwszfd.cn:9080/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/'+nm+'.docx'
                this.wsPdf = 'https://dapc1.scqwszfd.cn:8123/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/tupian/'+nm+'.pdf?timestrap='+new Date().getTime()
                 
                let bh = data.data[0].lsh.slice(0,4) + '-' + data.data[0].jdjl_bh
                this.$set(this.form,'bh',bh)
            }
        },
        getQzqk(){
            console.log(this.form.qzqk)
            if(this.form.gzqk=='0'){
                let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位立即改正。'
                this.$set(this.form,'jdyj',tet)
            }else{
                if(this.form.zgDay){
                    let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位'+this.form.zgDay+'日内整改完毕。'
                    this.$set(this.form,'jdyj',tet)
                }else{
                    let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位XX日内整改完毕。'
                    this.$set(this.form,'jdyj',tet)
                }
            }
        },
        getZgday(){
            console.log(this.form.zgDay)
            if(this.form.zgDay){
                let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位'+this.form.zgDay+'日内整改完毕。'
                this.$set(this.form,'jdyj',tet)
            }else{
                let tet = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位XX日内整改完毕。'
                this.$set(this.form,'jdyj',tet)
            }
        },
        submit(form){
            if(this.form.gzqk=='1' && !this.form.zgDay){
                this.$message.error('请填写整改天数！')
                return
            }
            let wupin = ''
            let nr = ''
            console.log(this.form)
            let zfzxj = ''//新旧执法证
            let day = this.form.gzqk=='0'? 0 : this.form.zgDay
            console.log(day)
            nr = this.form.bh + '|' + escape(this.form.jdyj) + '|' + day +'|'
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let that = this
                    this.loading = true
                    axios({
                        method: 'post',
                        url: `${this.Global._baseUrl2}`,
                        data: {
                            act: "makeWenshu",
                            id: `${this.pcId}`,
                            wsName:escape('卫生监督意见书'),
                            shuju: nr,
                            caozuoStatus:1,
                            isOldWenshu:'',
                            wupin:`${escape(wupin)}`,
                            gzbm:`${escape(this.gzbm)}`,
                            gzzw:`${escape(this.gzzw)}`,
                            xm:`${escape(this.xm)}`,
                            dm:`${this.dm}`,
                            shi:`${escape(this.shi)}`,
                            xianqu:`${escape(this.xianqu)}`,
                        },
                        transformRequest: [function (data) {
                            data = qs.stringify(data);
                            return data;
                        }],
                        headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                    }).then(res => {
                        this.loading = false
                        console.log(res)
                        if(res.data.code != -1){
                            console.log(res.data.code)
                            //code: "1"
                            //data: "showpdf.html?mid=dw400&lsh=202400096&wsnameEw=weishengjianduyijianshu&sjs=20240625144456060"
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.wsUrl = res.data.data.split('?')[1]
                            this.show()
                        }else{
                            if(res.data.data){
                                this.$message.error(res.data.data)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                }
            })
        },
        async getWh(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblBh&id=${this.pcId}`)
            console.log(data)
            if(data.data){
                if(data.data.errMessage){
                    this.$set(this.form,'bh',data.data.errMessage)
                }else{
                    let bh = new Date().getFullYear() + '-'
                    this.$set(this.form,'bh',bh)
                }
            }
        },
        async getNr(){
            this.open = true
            this.jdnr = '针对'+this.anyou+'的行为，依据'+this.cfyj+'的规定，责令你单位'
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfmbXX&leibie=${escape('违法事实')}`)
            // console.log(data)
            // if(data.data){

            // }
        },
        cancel(){
            this.form = {}
            this.open = false
        },
        handleBackJdyj(data){
            this.form.jdyj = this.form.jdyj+data
            this.open = false
        },
        closeJdyj(data){
            this.open = false
        },
        show(){
            if(this.wsUrl){
                let mid = this.wsUrl.split('&')[0].replace('mid=','')
                let lsh = this.wsUrl.split('&')[1].replace('lsh=','')
                let wsname = this.wsUrl.split('&')[2].replace('wsnameEw=','')
                let sjs = this.wsUrl.split('&')[3].replace('sjs=','')
                let url = this.$router.resolve({
                    path:'/pdf',
                    query:{
                        mid:mid,
                        lsh:lsh,
                        wsname:wsname,
                        sjs:sjs
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl){
                let url = this.docurl
                console.log(url)
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf){
                window.open(this.wsPdf,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            let wsname = 'weishengjianduyijianshu.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.zfXX[0].dwmc_id}&lsh=${this.zfXX[0].lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
</style>